"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KontaktHero() {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  useEffect(() => {
    const handleScroll = () => {
      if (!parallaxRef.current) return;
      const scrolled = window.scrollY;
      parallaxRef.current.style.transform = `translateY(${scrolled * 0.5}px)`;
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="kontakt-hero" className="dark bg-background text-foreground relative h-screen w-full overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 w-full h-[120%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/pristine_roof_dramatic_lighting.png)]" style={{
      willChange: "transform"
    }} />

      {}

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        <div className={`max-w-4xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-none mb-6">
            Kontaktujte nás<span className="text-primary">.</span>
          </h1>

          {}
          <p className="text-lg font-sans mb-12 max-w-2xl mx-auto leading-relaxed !text-[hsl(210,17%,98%)] sm:text-xl md:text-2xl">
            Rádi odpovíme na vaše dotazy a připravíme vám nabídku na míru.
          </p>

          {}
          <Link to="#contact-form" className="inline-block">
            
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-primary/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-primary rounded-full animate-bounce" />
        </div>
      </div>
    </section>;
}